import * as React from 'react';
import { Collapse } from 'react-bootstrap';
import { UserMenu } from 'moduleBase/types/Menu';
import { FC } from 'react';
import { ProfileInfoContent } from '../components/ProfileInfoContent/ProfileInfoContent';

type UserPanelProps = {
  isVisible: boolean,
  hide: () => void,
  userMenu: UserMenu,
};

const UserPanel: FC<UserPanelProps> = ({ isVisible, userMenu, hide }) => (
  <Collapse in={isVisible}>
    <div className="dropdown-flat-menu">
      <ProfileInfoContent userMenu={userMenu} hide={hide} />
    </div>
  </Collapse>
);

export default UserPanel;
